import React from 'react'

import MemorialAddModal from './MemorialAddModal'

import containers from './containers'
import editContainers from './editContainers'

export const DecoratedMemorialOrder = containers(MemorialAddModal)
const DecoratedMemorialOrderEdit = editContainers(MemorialAddModal)

export const MemorialOrderAddFormModal = ({ name }) => <DecoratedMemorialOrder name={name} OperTypeID={1} />

export const MemorialOrderEdit = ({ name, onOrderAddEdit, onAuthorize }) => (
  <DecoratedMemorialOrderEdit OperTypeID={1} name={name} onAuthorize={onAuthorize} onOrderAddEdit={onOrderAddEdit} />
)

export const MemorialOrderCopy = ({ name, onOrderAddEdit }) => (
  <DecoratedMemorialOrderEdit OperTypeID={1} copyOrder name={name} onOrderAddEdit={onOrderAddEdit} />
)
